<template>
  <div :class="['category-list']">
    <example-title :title="`${['components', 'form-elements', 'directives'].indexOf(type) !== -1 ? items.length - 1 : ''} ${title}`" v-if="title" />
    <vc-layout :spacing="spacing">
      <vc-col :span="span" v-for="(item, index) in items" v-if="!item.hide" :key="index" :class="['align-center']" md12 xs24>
        <vc-card tag="router-link" :href="item.path" :class="['elevation-6']">
          <vc-card-media height="82px">
            <vc-icon :class="['my-16']" :color="color" size="x-large">{{ item.icon || 'mdi-view-dashboard' }}</vc-icon>
          </vc-card-media>
          <vc-card-title :color="color" :dark="false">
            <h2 is="span" :class="['body-2', 'vc-block']" v-html="item.label" />
          </vc-card-title>
        </vc-card>
      </vc-col>
    </vc-layout>
  </div>
</template>
<script>
export default {
  name: 'CategoryList',
  data () {
    return {
      items: []
    }
  },
  computed: {
    color () {
      return this.$store.getters.categoryColor || 'primary'
    }
  },
  props: {
    span: {
      type: Number,
      required: false,
      default: 8
    },
    spacing: {
      type: Number,
      required: false,
      default: 8
    },
    title: {
      type: String,
      required: false
    },
    type: {
      type: String,
      required: true
    },
    sort: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  mounted () {
    const routes = this.$router.options.routes.filter(item => item.type === this.type)
    if (!this.sort) {
      this.items = routes
      return
    }
    this.items = routes.sort((a, b) => {
      if (a.name < b.name) {
        return -1
      }
      if (a.name > b.name) {
        return 1
      }
      return 0
    })
  }
}
</script>
<style>
.category-list a
{
  text-decoration: none;
}

.category-list .vc-card
{
  transition: transform .2s cubic-bezier(.600, 0, .735, .045);
}

.category-list .vc-card:hover
{
  transform: scale(1.025);
}
</style>



// WEBPACK FOOTER //
// src/components/category-list/CategoryList.vue